import Typesense from 'typesense';

import { typesenseConfig } from '@/config';

export const typesense = new Typesense.Client(typesenseConfig);
